import { QueryClient } from '@tanstack/react-query';

// React Query 클라이언트 설정
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 기본 stale time: 5분
      staleTime: 5 * 60 * 1000,
      // 기본 gc time: 10분
      gcTime: 10 * 60 * 1000,
      // 윈도우 포커스 시 자동 refetch 비활성화
      refetchOnWindowFocus: false,
      // 네트워크 재연결 시 자동 refetch
      refetchOnReconnect: true,
      // 백그라운드에서 자동 refetch 비활성화
      refetchOnMount: true,
      // 재시도 설정
      retry: (failureCount, error: any) => {
        // 4xx 에러는 재시도하지 않음
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // 최대 3번 재시도
        return failureCount < 3;
      },
      // 재시도 지연 시간 (지수 백오프)
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // 뮤테이션 재시도 설정
      retry: (failureCount, error: any) => {
        // 4xx 에러는 재시도하지 않음
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // 최대 1번 재시도
        return failureCount < 1;
      },
    },
  },
});

// React Query v5에서는 onError가 제거되었으므로
// 에러 핸들링은 각 쿼리/뮤테이션에서 개별적으로 처리하거나
// 글로벌 에러 바운더리를 사용해야 합니다.

// 글로벌 에러 핸들러 함수 (필요시 각 쿼리에서 사용)
export const handleContentError = (error: any) => {
  console.error('Content error:', error);

  // 인증 에러 처리
  if (error?.response?.status === 401) {
    console.warn('Authentication required');
    // 로그인 페이지로 리다이렉트 또는 토큰 갱신 로직
  }

  // 권한 에러 처리
  if (error?.response?.status === 403) {
    console.warn('Access forbidden');
  }

  // API 에러 메시지 로깅
  if (error?.response?.data?.message) {
    console.error('API Error:', error.response.data.message);
  }
};
